import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  base: {
    paddingInline: theme.spacing(2),
  },
}));
